import axios, { type AxiosInstance } from 'axios';
import { getAuth } from 'firebase/auth';

export function createApiClient(): AxiosInstance {
  const client = axios.create({
    baseURL: import.meta.env.VITE_API_GATEWAY ?? 'https://teleclaw.ncide.com/api',
    timeout: 30_000,
  });

  client.interceptors.request.use(async (config) => {
    const user = getAuth().currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  client.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err.response?.status === 401) {
        // Token истёк — Firebase обновит автоматически на следующем запросе
        getAuth().currentUser?.getIdToken(true).catch(() => undefined);
      }
      return Promise.reject(err);
    },
  );

  return client;
}

export const api = createApiClient();
